import { rejectInvalidSyncKey } from 'serviceWorker/services/factories/invalidSyncKey';
import { InspectionInDto } from 'shared/dtos/in/inspection';
import {
  defaultConfig,
  generateHeaders,
  makeNormalizeResponse,
} from '../../helpers/httpRequests';
import {
  HeadersData,
  NormalizedEntityResponseData,
} from '../factories/types';
import { pull } from '../pull';

const parseResponse =
  makeNormalizeResponse<InspectionInDto>('inspections');

export const fetchInspections = (
  data: HeadersData,
  controller: AbortController
): Promise<NormalizedEntityResponseData<InspectionInDto>> | undefined => {
  const { signal } = controller;
  if (shouldSkip(data, signal)) {
    return;
  }
  const builtUrl = `${data.api}/v2/project/${data.projectId}/inspection`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  }).then(parseResponse);
};

export const fetchUpdatedInspections = (
  data: HeadersData,
  syncKey: string,
  controller: AbortController
): Promise<NormalizedEntityResponseData<InspectionInDto>> | undefined => {
  const { signal } = controller;
  if (!data.api || !data.projectId) {
    return;
  }
  const builtUrl = `${data.api}/v2/project/${
    data.projectId
  }/inspection?syncKey=${encodeURIComponent(syncKey)}`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  })
    .then((response: Response) => rejectInvalidSyncKey(response, 'inspections'))
    .then(parseResponse);
};

function shouldSkip(data: HeadersData, signal: AbortSignal): boolean {
  return !data.api || !data.projectId || signal.aborted;
}
